<template>
  <HeaderNavbar :title="$t('settings.linked_networks.title')" :breadcrumbs="listBreadcrumbs">
    <template #right-side>
      <div class="d-flex gap-3">
        <a class="btn btn-primary" :href="redirect_uri" target="_blank">
          <IconBrandFacebook :size="16" class="me-1" />
          {{ $t('settings.linked_networks.facebook.button') }}
        </a>
      </div>
    </template>
  </HeaderNavbar>
  <div class="container-lead row">
    <div class="col-12 col-md-4" v-for="network in networks" :key="network.id">
      <div class="card">
        <div class="card-body d-flex gap-3 align-items-center">
          <img :src="network.facebook_page_image" class="avatar" />
          <h4 class="m-0">{{ network.name }}</h4>
          <IconTrash size="20" class="text-danger ms-auto" role="button" @click="setConfirmationDialog(network.id)" />
        </div>
      </div>
    </div>
    <div v-if="!networks?.length" class="card">
      <div class="card-body d-flex flex-column justify-content-center align-items-center my-4">
        <IconMoodEmpty size="50" class="text-muted mb-2" />
        <h3 class="text-muted">{{ $t('settings.linked_networks.no_networks') }}</h3>
      </div>
    </div>
  </div>
  <FacebookAuthModal />
  <LiConfirmationDialog
    v-model:dialogShow="deleteModalOpen"
    :confirmButtonLabel="$t('btn.delete')"
    @onContinue="deleteLinkedNetwork">
    <h1 class="mb-3">{{ $t('settings.linked_networks.delete_facebook.title') }}</h1>
    <p>{{ $t('settings.linked_networks.delete_facebook.description') }}</p>
  </LiConfirmationDialog>
</template>
<script setup lang="ts">
import { deleteFacebookNetwork, fetchFacebookNetworks, fetchFacebookRedirectionURI } from '@/api/network';
import FacebookAuthModal from '@/components/settings/FacebookAuthModal.vue';
import translator from '@/locale/translator';
import HeaderNavbar from '@/components/header/HeaderNavbar.vue';
import { ConfirmationDialog as LiConfirmationDialog } from '@prospective/lithium';

import { IconBrandFacebook, IconMoodEmpty, IconTrash } from '@tabler/icons-vue';
import { onMounted, ref } from 'vue';

const listBreadcrumbs = [
  { label: translator.get('nav.settings'), path: { name: 'settings' } },
  { label: translator.get('settings.linked_networks.title'), path: { name: 'settings.networks' } },
];
const networks = ref<any[]>([]);
const deleteModalOpen = ref(false);
const deleteNetworkId = ref<number>();
const redirect_uri = ref('');

onMounted(async () => {
  await fetchFacebookRedirectionURI()
    .then((response) => {
      redirect_uri.value = response.redirect_url;
    })
    .catch(() => {
      redirect_uri.value = '';
    });
  fetchFBNetworks();
});

async function fetchFBNetworks() {
  await fetchFacebookNetworks()
    .then((response) => {
      networks.value = response.data;
    })
    .catch(() => {
      networks.value = [];
    });
}

function setConfirmationDialog(networkId?: number) {
  deleteNetworkId.value = networkId;
  if (deleteNetworkId.value) {
    deleteModalOpen.value = true;
  }
}

async function deleteLinkedNetwork() {
  if (!deleteNetworkId.value) return;
  // Call API to delete the network
  deleteFacebookNetwork(deleteNetworkId.value).then(() => {
    // Refresh the list after deletion
    fetchFBNetworks();
    setConfirmationDialog(undefined);
  });
}
</script>
